var exports = {
  "k": "InviteDateToggle.module__container___QnlMU2",
  "P": "InviteDateToggle.module__label___QnlMU2",
};

module.exports = exports;
